import { render } from "./AccountList.vue?vue&type=template&id=b2a82af2"
import script from "./AccountList.vue?vue&type=script&lang=js"
export * from "./AccountList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__